<template>
<div class="wrp-header sticky-top">
    <div class="p-3">
        <!-- Menu Icon -->
        <a class="mr-3" v-if="btnMenu && !isSearchActive"><img src="@/assets/images/icon-menu.png" @click="toggleMenu" /></a>
        <!-- Back Icon -->
        <a class="mr-3" v-if="btnBack" @click="goBack"><md-icon>arrow_back</md-icon></a>
        <!-- Back to Create Invoice -->
        <a class="mr-3" v-if="btnBackToCreateInvoice" @click="goBackToInvoice"><md-icon>arrow_back</md-icon></a>
        <!-- Back to All Invoices -->
        <a class="mr-3" v-if="btnBackToAllInvoices" @click="goBackToAllInvoices()"><md-icon>arrow_back</md-icon></a>
        <!-- Close Button -->
        <a class="mr-3" v-if="btnClose" @click="goBack"><md-icon>close</md-icon></a>
        <!-- Page title -->
        <span :class="[isSearchActive ? 'display-none' : 'title']">{{ prettyTitle($route.params.slug || $route.meta.title) }}</span>
        <!-- Item Page Options Butotn  -->
        <a class="float-right" v-if="btnItemOptions" @click="toggleItemOptions"><md-icon>more_vert</md-icon></a>
        <!-- Invoice Page Options Button  -->
        <a class="float-right" v-if="btnInvoiceOptions" @click="toggleInvoiceOptions"><md-icon>more_vert</md-icon></a>
        <!-- Save Item Details Tick Mark  -->
        <a class="float-right" v-if="btnTickEditItem" @click="editItem"><md-icon>check</md-icon></a>
        <!-- Search Button & Input  -->
        <a
        :class="[isSearchActive ? searchActive : 'float-right']"
        @click="search"
        v-if="btnSearch">
          <md-icon v-if="!isSearchActive">search</md-icon>
          <md-icon
          v-if="isSearchActive"
          class="search-input-close"
          @click.native="clearSearchInput">close</md-icon>
          <input
          v-model="searchQuery"
          :class="[isSearchActive ? 'search-input' : 'display-none']"
          v-on:keyup.enter="searchInvoice"
          placeholder="Search">
        </a>
        <!-- Close Search Button  -->
        <a class="mr-3 float-left" v-if="isSearchActive" @click="closeSearch"><md-icon>arrow_back</md-icon></a>
        <!-- Done Create Item -->
        <a class="float-right" v-if="btnItemCreate" @click="createItemDialog"><md-icon>check</md-icon></a>
        <!--Done Edit Item-->
        <a class="float-right" v-if="btnItemEdit" @click="editItemDialog"><md-icon>check</md-icon></a>
        <!-- Item Page Options  -->
        <div class="item-options header-options md-elevation-7" v-if="item_options">
          <md-list>
              <md-list-item @click="resetItemDialog">Discard Changes</md-list-item>
              <!--<md-list-item @click="editItemDialog">Save</md-list-item>-->
              <!-- <md-list-item @click="deleteItemDialog">Delete</md-list-item> -->
          </md-list>
        </div>
        <!-- Invoice Page Options  -->
        <div class="item-options header-options md-elevation-7" v-if="invoice_options">
          <md-list>
            <md-list-item v-if="$route.name == 'create_invoice'" @click="saveInvoiceDialog">Save</md-list-item>
            <md-list-item v-if="$route.name == 'edit_invoice'" @click="editInvoiceDialog">Save</md-list-item>
            <md-list-item v-if="$route.name == 'edit_invoice'" @click="deleteInvoiceDialog">Delete</md-list-item>
            <md-list-item @click="markAsSentDialog">Mark as sent</md-list-item>
          </md-list>
        </div>
        <!-- Done Create Contact Person -->
        <a class="float-right" v-if="btnContactPersonCreate" @click="createContactPersonDialog"><md-icon>check</md-icon></a>
        <!-- Contact Person Page Options Button  -->
        <a class="float-right" v-if="btnContactPersonOptions" @click="toggleContactPersonOptions"><md-icon>more_vert</md-icon></a>
        <!-- Contact Person Options -->
        <div class="item-options header-options md-elevation-7" v-if="contact_person_options">
            <md-list>
                <md-list-item v-if="$route.name == 'edit_person'" @click="editPersonDialog">Save</md-list-item>
                <md-list-item v-if="$route.name == 'edit_person'" @click="deletePersonDialog">Delete</md-list-item>
            </md-list>
        </div>
        <!-- Done Create Contact Business -->
        <a class="float-right" v-if="btnContactBusinessCreate" @click="createContactBusinessDialog"><md-icon>check</md-icon></a>
        <!-- Contact Business Page Options Button  -->
        <a class="float-right" v-if="btnContactBusinessOptions" @click="toggleContactBusinessOptions"><md-icon>more_vert</md-icon></a>
        <!-- Contact Business Options -->
        <div class="item-options header-options md-elevation-7" v-if="contact_business_options">
            <md-list>
                <md-list-item v-if="$route.name == 'edit_business'" @click="editBusinessDialog">Save</md-list-item>
                <md-list-item v-if="$route.name == 'edit_business'" @click="deleteBusinessDialog">Delete</md-list-item>
            </md-list>
        </div>
    </div>

    <!-- Tab List  -->
    <ul v-if="tabList" class="nav nav-justified sticky-top wrp-tab">
        <b-link
          class="nav-item nav-link"
          v-for="(tabParam, index) in tabList.params"
          :key="index"
          :to="{ name: tabList.name, params: { cat: tabParam }}">
          {{ tabParam | prettier }}
        </b-link>
    </ul>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import * as $$ from 'lodash'

export default {
    props: {
        btnMenu: Boolean,
        btnBack: Boolean,
        btnBackToCreateInvoice: Boolean,
        btnBackToAllInvoices: Boolean,
        btnSearch: Boolean,
        btnClose: Boolean,
        btnTick: Boolean,
        btnItemOptions: Boolean,
        btnInvoiceOptions: Boolean,
        btnTickEditItem: Boolean,
        tabList: Object,
        edit_item: Object,
        edit_item_id: Number,
        invoice_draft: Object,
        invoice_details: Object,
        invoice_id: Number,
        contactType: Object,
        btnContactPersonOptions: Boolean,
        btnContactBusinessOptions: Boolean,
        contact_person_id: Number,
        contact_business_id: Number,
        btnContactPersonCreate: Boolean,
        btnContactBusinessCreate: Boolean,
        btnItemCreate: Boolean,
        btnItemEdit: Boolean,
    },
    data() {
      return {
        expandNews: false,
        item_options: false,
        invoice_options: false,
        isSearchActive: false,
        searchActive: {
          'margin-right': 'auto'
        },
        searchQuery: null,
          contact_person_options: false,
          contact_business_options: false,
      }
    },
    filters: {
        prettier: function(value) {
            if (!value) return ''
            value = value.toString()
              .split('_')
              .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
              .join(' ')
            return value
        }
    },
    created() {
        this.$root.$on('update-invoice-search-query', vars => {
            this.searchQuery = vars;
            this.searchInvoice();
        })
    },
    methods: {
      ...mapMutations('auth', ['toggleDrawer']),
      ...mapActions('invoice', ['clearCreateInvoiceData', 'clearEditInvoiceData', 'setIsEditingInvoice']),
        goBack() {
            window.history.length > 1 ?
                this.$router.go(-1) :
                this.$router.push('/login')
        },
        goBackToInvoice() {
          this.$router.push('create_invoice')
        },
        goBackToAllInvoices() {
          this.clearCreateInvoiceData();
          this.clearEditInvoiceData();
          this.setIsEditingInvoice(false);
          this.$router.push('/invoices/all')
        },
        prettyTitle(title) {
            return title.replace(/_/g, " ");
        },
        toggleMenu () {
          this.toggleDrawer();
          this.$root.$emit('show-drawer', this.$store.menuVisible);
        },
        toggleItemOptions() {
          this.item_options = !this.item_options
        },
        toggleInvoiceOptions() {
          this.invoice_options = !this.invoice_options
        },
        toggleContactPersonOptions() {
            this.contact_person_options = !this.contact_person_options
        },
        toggleContactBusinessOptions() {
            this.contact_business_options = !this.contact_business_options
        },
        discardChanges() {
            this.$root.$emit('discardInvoiceChanges');
            this.toggleInvoiceOptions()
        },
        saveInvoiceDialog() {
            this.$confirmationToast("Save Invoice?", "Are you sure you want to save this invoice?", this.saveInvoiceDraft, null);
        },
        saveInvoiceDraft() {

            this.$root.$emit('show-loading', true);

            this.axios({
            method: 'post',
            url: 'sales/invoices',
            data: this.invoice_draft,
          }).then(function(response) {
                this.$root.$emit('show-loading', false);
                this.$store.commit('clearItems')
            this.$store.commit('clearSelectedContact')
              this.$successToast('Invoice successfully edited.')
              this.$router.go(-1)
          }).catch(error => {
                this.$root.$emit('show-loading', false);
            console.log(error.response)
          })
        },
        editInvoiceDialog() {
            this.$confirmationToast("Edit Invoice?", "Are you sure you want to edit this invoice?", this.editInvoiceDraft, null);
        },
        editInvoiceDraft() {
          console.log(this.$store.state.invoice.editInvoiceObj);
          let invoiceFromStore = this.$store.state.invoice.editInvoiceObj;
          let invoiceToPut = {};
          let formatedPartial = [];
          let formatedItem = [];

          $$.each(invoiceFromStore.partials, (partial)=> {
            if (partial.is_deleted) {
              formatedPartial.push({
                is_deleted: partial.is_deleted,
                id: partial.id
              }); 
            } else {
              formatedPartial.push({
                account_id: partial.account_id,
                method_id: partial.method_id,
                amount: partial.amount
              });
            }
          });
          $$.each(invoiceFromStore.items, (item, index) => {
            formatedItem.push({
                name: item.name,
                line: item.line,
                quantity: item.quantity,
                unit_price: item.unit_price,
                id: item.id
            })
            if (item.product_id) {
                formatedItem[index].product_id = item.product_id;
            }
            if (item.account_id){
                formatedItem[index].account_id = item.account_id;
            }
            if (item.tax_code_id){
              formatedItem[index].tax_code_id = item.tax_code_id.id;
            }
          });
          invoiceToPut = {
            contact_id : invoiceFromStore.contact_id,
            currency_id: invoiceFromStore.currency.id,
            currency_rate: invoiceFromStore.currency_rate,
            date: invoiceFromStore.date,
            is_cash_term: true,
            is_progress_payment: false,
            is_recurring: false,
            items: formatedItem,
            memo: invoiceFromStore.memo,
            no: invoiceFromStore.no,
            partials: formatedPartial,
            tags: [],
            term_id: invoiceFromStore.term.id,
            tax_inclusive: false,
            recurring_id: 0,
            progress_pays: []

          }
          if (invoiceFromStore.term.name !== 'Cash') {
              invoiceToPut.is_cash_term = false;
              invoiceToPut.due_date = invoiceFromStore.due_date
          }

          console.log(invoiceToPut);
            this.$root.$emit('show-loading', true);
            this.axios({
            method: 'put',
            url: 'sales/invoices/' + invoiceFromStore.id,
            data: invoiceToPut,
          }).then(() => {
              this.$successToast('Invoice successfully edited.')
              this.$root.$emit('show-loading', false);
              this.goBack()
          }).catch(error => {
              this.$root.$emit('show-loading', false);
              this.$generalAPIErrorHandling(error, this.$router);
          })
        },
        deleteInvoiceDialog() {
            this.$confirmationToast("Delete Invoice?", "Are you sure you want to delete this invoice?", this.deleteInvoice, null);
        },
        deleteInvoice() {

            this.$root.$emit('show-loading', true);
            this.axios({
            method: 'delete',
            url: 'sales/invoices/' + this.invoice_id
          }).then(response => {
              this.$root.$emit('show-loading', false);
            this.$router.push('/invoices/all')
          }).catch(error => {
              this.$root.$emit('show-loading', false);
              this.$generalAPIErrorHandling(error, this.$router);
          })
        },
        createItemDialog() {
            this.$root.$emit('attempt_submit_create_item');
        },
        editItemDialog() {
            this.$root.$emit('attempt_submit_edit_item');
        },
        deleteItemDialog() {
            this.$confirmationToast("Delete Item?", "Are you sure you want to delete this item?", this.deleteItem, null);
        },
        resetItemDialog() {
            this.$root.$emit('discardItemChanges');
            this.toggleItemOptions();
        },
        deleteItem() {
            this.$root.$emit('show-loading', true);
            this.axios({
                method: 'put',
                url: '/products/' + this.edit_item_id + '/active',
                data: {
                    is_active: 0
                }
            }).then(response => {
                this.$root.$emit('show-loading', false);
                this.$router.push('/items/all')
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            })
        },
        search() {
          this.isSearchActive = true
          this.$store.dispatch('set_search_is_active')
        },
        closeSearch() {
          this.isSearchActive = false
          this.$store.dispatch('set_search_is_inactive')
          this.$store.dispatch('clear_invoice_search_result')
        },
        clearSearchInput() {
          this.searchQuery = null
            this.$store.dispatch('clear_invoice_search_query');
        },
        searchInvoice() {
            this.$store.dispatch('set_invoice_search_query', this.searchQuery);
          var company = this.$store.state.selected_company

            this.$root.$emit('show-loading', true);
            this.axios({
            method: 'get',
            url: 'sales',
            params: {
              entity_id: company,
              type: 'SALE_INVOICE',
              query: this.searchQuery
            }
          }).then(response => {
                this.$root.$emit('show-loading', false);
            this.$store.dispatch('set_invoice_search_result', response.data.transactions)
          }).catch(error => {
                this.$root.$emit('show-loading', false);
            console.log(error)
          })
        },
        markAsSentDialog() {
            this.$confirmationToast("Mark As Sent Invoice?", "Are you sure you want to mark as sent this invoice?", this.markAsSent, null);
        },
        markAsSent() {

            this.$root.$emit('show-loading', true);
            this.axios({
                method: 'put',
                url: '/sales/invoices/' + this.invoice_id + '/status',
                data: {
                    status: 1
                }
            }).then(response => {
                this.$root.$emit('show-loading', false);
                this.$router.push('/invoices/all')
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            })
        },
        editPersonDialog() {
            this.$root.$emit('attempt_submit_edit_person');
        },
        deletePersonDialog() {
            this.$confirmationToast("Delete Person?", "Are you sure you want to delete this person?", this.deletePerson, null);
        },
        deletePerson() {
            this.$root.$emit('show-loading', true);
            this.axios({
                method: 'delete',
                url: '/contacts/unused/' + this.contact_person_id
            }).then(response => {
                this.$root.$emit('show-loading', false);
                this.$router.push('/contacts/all')
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            })
        },
        createContactPersonDialog() {
            this.$root.$emit('attempt_submit_create_person');
        },
        editBusinessDialog() {
            this.$root.$emit('attempt_submit_edit_business');
        },
        deleteBusinessDialog() {
            this.$confirmationToast("Delete Business?", "Are you sure you want to delete this business?", this.deleteBusiness, null);
        },
        deleteBusiness() {
            this.$root.$emit('show-loading', true);
            this.axios({
                method: 'delete',
                url: '/contacts/unused/' + this.contact_business_id
            }).then(response => {
                this.$root.$emit('show-loading', false);
                this.$router.push('/contacts/all')
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            })
        },
        createContactBusinessDialog() {
            this.$root.$emit('attempt_submit_create_business');
        },
    },
    computed: {
      ...mapState([
        'menuVisible',
        'isActive',
      ])
    },
}
</script>

<style lang="scss">
  a {
    .md-icon.search-input-close {
      font-size: 1rem;
    }

    .search-input {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid white;
      color: white;
      width: calc(100% - 45px);
    }

    ::placeholder {
      color: white;
    }

    .search-input-close {
      position: absolute;
      right: 15px;
      font-size: 1rem !important;
    }
  }
</style>
